import { queryOptions } from "@tanstack/react-query";
import { getTemplateBySlug, listAllTemplates, listTemplates } from "./templates.functions";

export type SiteTemplate = {
  id: string;
  slug: string;
  name: string;
  description: string | null;
  hero_image_path: string | null;
  hero_kicker: string | null;
  hero_title: string | null;
  hero_subtitle: string | null;
  body_md: string;
  seo_title: string | null;
  seo_description: string | null;
  is_published: boolean;
  created_at: string;
  updated_at: string;
};

export const templatesQueryOptions = () =>
  queryOptions({
    queryKey: ["site_templates"],
    queryFn: async () => (await listTemplates()) as SiteTemplate[],
  });

/**
 * Admin > Templates list ONLY: every row, unpublished ones included (admin
 * token required). Everything else, the navigation template picker included,
 * stays on templatesQueryOptions so it never offers an unpublished page. The
 * key sits under "site_templates", so the existing invalidation refreshes it.
 */
export const allTemplatesQueryOptions = () =>
  queryOptions({
    queryKey: ["site_templates", "admin-all"],
    queryFn: async () => (await listAllTemplates()) as SiteTemplate[],
  });

export const templateBySlugQueryOptions = (slug: string) =>
  queryOptions({
    queryKey: ["site_templates", "slug", slug],
    queryFn: async () => (await getTemplateBySlug({ data: { slug } })) as SiteTemplate | null,
  });

export const TEMPLATE_VARIABLES: { token: string; label: string; description: string }[] = [
  { token: "[HERO:Slideshow]", label: "Hero Slideshow", description: "Database-driven hero slideshow." },
  { token: "[LIST:OurTeam]", label: "Our Team", description: "Grid of team members with bio dialogs." },
  { token: "[LIST:AdvisoryBoard]", label: "Advisory Board", description: "AIA Industry Advisory Board grid." },
  { token: "[LIST:Sponsors]", label: "Sponsors", description: "Sponsor logos grouped by tier." },
  { token: "[LIST:Insights]", label: "Insights", description: "Latest Aesthetic Insights articles." },
  { token: "[FORM:Contact]", label: "Contact Form", description: "Public contact form; submissions land in Admin > Messages." },
  { token: "[FORM:AxInquiry]", label: "Ax Incubator Inquiry", description: "Startup inquiry form with a company field." },
];
